<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
      <div class="container">
        <h2>About Us</h2>
        <p>Dedicated to <span class="marathi-font">"आदिकरण श्री दत्तात्रेय प्रभू, श्री गुरुवर्य आणि अखिल परमार्ग"</span></p>
      </div>
    </div><!-- End Breadcrumbs -->

    <!-- ======= Trainers Section ======= -->
    <section id="trainers" class="trainers">
        <div class="container" data-aos="fade-up">
  
          <div class="row" data-aos="zoom-in" data-aos-delay="100">
            <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <img src="../assets/images/AniruddhaBhave_n.jpg" class="img-fluid" alt="">
                <div class="member-content">
                  <h4 class="marathi-font">श्री अनिरुद्ध भावे</h4>
                  <span>Director</span>
                  <p class="marathi-font">
                    न्यू मनिष नगर, नागपूर <br>
                    महाराष्ट्र, भारत - ४४००२६ <br>
                    <strong>Phone:</strong> (+91) 9850149316<br>
                    <strong>Email:</strong> aniruddha.bhave1962@gmail.com<br>
                  </p>
                  <div class="social">
                    <a href=""><i class="bi bi-twitter"></i></a>
                    <a href=""><i class="bi bi-facebook"></i></a>
                    <a href=""><i class="bi bi-instagram"></i></a>
                    <a href=""><i class="bi bi-linkedin"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                <div class="member">
                  <img src="../assets/images/kartikbhave.jpg" class="img-fluid" alt="">
                  <div class="member-content">
                    <h4 class="marathi-font">श्री कार्तिक भावे</h4>
                    <span>Senior Lead, Enginnering</span>
                    <p class="marathi-font">
                        रुक्मिणी नगर, नागपूर<br>
                        महाराष्ट्र, भारत - ४४००२४<br>
                      <strong>Phone:</strong> (+91) 9730896084<br>
                      <strong>Email:</strong> kartikbhave.scs@gmail.com<br>
                    </p>
                    <div class="social">
                      <a href=""><i class="bi bi-twitter"></i></a>
                      <a href=""><i class="bi bi-facebook"></i></a>
                      <a href=""><i class="bi bi-instagram"></i></a>
                      <a href=""><i class="bi bi-linkedin"></i></a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                <div class="member">
                  <img src="../assets/images/adityabhave.jpg" class="img-fluid" alt="">
                  <div class="member-content">
                    <h4 class="marathi-font">श्री आदित्य भावे</h4>
                    <span>Senior Software Engineer</span>
                    <p class="marathi-font">
                        न्यू मनिष नगर, नागपूर <br>
                        महाराष्ट्र, भारत - ४४००२६ <br>
                        <strong>Phone:</strong> (+91) 9503108413<br>
                        <strong>Email:</strong> adityabhave1994@gmail.com<br>
                      </p>
                    <div class="social">
                      <a href=""><i class="bi bi-twitter"></i></a>
                      <a href=""><i class="bi bi-facebook"></i></a>
                      <a href=""><i class="bi bi-instagram"></i></a>
                      <a href=""><i class="bi bi-linkedin"></i></a>
                    </div>
                  </div>
                </div>
              </div>
  
          </div>
  
        </div>
      </section><!-- End Trainers Section -->
  
    </main><!-- End #main -->